const splashText = {
    "en": {
        "adrienne_audio": "Listen to a recording from Lénaïg Cariou & Camille Blanc's recent workshop on translating gender (FR)",
    },
    "fr": {
        "adrienne_audio": "Traduire en féministe: exergues des traductions sorties d'un atelier mené par Lénaïg Cariou et Camille Blanc (FR)",
    },
};

export default splashText;
